/* eslint-disable import/prefer-default-export */
import { API } from 'aws-amplify';

export const hostReadEvent = (hostId, eventId) =>
  API.get('eventmanager-public', `/public/event/${eventId}/${hostId}`, { });

export const guestReadEvent = (hostId, eventId) =>
  API.get('eventmanager-public', `/public/event/${eventId}/${hostId}`, { });

export const hostAddGuests = (hostId, eventId, guests) =>
  API.get('eventmanager-public', `/public/event/${eventId}/${hostId}`, { body: { guests } });

export const ceoReadTraining = (trainingId, ceoId) =>
  API.get('eventmanager-public', `/public/training/${trainingId}/${ceoId}`, { });

export const ceoRemoveGuest = (trainingId, guestId) =>
  API.del('eventmanager-public', `/public/training/${trainingId}/guest/${guestId}`, { });

export const ceoCreateGuest = (trainingId, ceoId, guest) =>
  API.put('eventmanager-public', `/public/training/${trainingId}/guest`, { body: { guest, ceoId } });

export const ceoAddGuests = (trainingId, ceoId, guests) =>
  API.post('eventmanager-public', `/public/training/${trainingId}/guests`, { body: { guests, ceoId } });
//
// export const readEvent = (eventId, guestId) =>
//   API.get('eventmanager-public', `/public/event/${eventId}/${guestId}`, { });
//
// export const removeTrainingGuest = (trainingId, guestId) =>
//   API.del('eventmanager-public', `/public/training/${trainingId}/guest/${guestId}`, { });
//
// export const addTrainingGuests = (trainingId, ceoId, guests) =>
//   API.post('eventmanager-public', `/public/training/${trainingId}/guests`, { body: { guests, ceoId } });
//
// export const createTrainingGuest = (trainingId, ceoId, guest) =>
//   API.put('eventmanager-public', `/public/training/${trainingId}/guest`, { body: { guest, ceoId } });
//
// export const updateEventInvitation = (eventId, guestId, guest) =>
//   API.post('eventmanager-public', `/public/event/${eventId}/${guestId}`, { body: { guest } });
